
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 34"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#69B1B8"}},[_c('path',{attrs:{"d":"M19.504 25.147l-1.843-4.6h-.96v5.637h.743v-2.195l-.073-2.358 1.846 4.553h.57l1.85-4.564-.069 2.369v2.195h.743v-5.637h-.964zm-7.47-3.988h1.808v5.025h.739v-5.025h1.812v-.612h-4.359zm-.962 1.812H8.23v-2.424h-.743v5.637h.743v-2.605h2.842v2.605h.747v-5.637h-.747zm12.77-2.424h-.747v5.637h3.419v-.607h-2.672z"}}),_c('path',{attrs:{"d":"M29.467 8.612l-7.359-7.358A.86.86 0 0021.497 1H5.144a.865.865 0 00-.865.865v30.27c0 .478.388.865.865.865h23.712a.865.865 0 00.865-.865V9.223c0-.23-.092-.45-.254-.611zm-8.08-5.634l6.325 6.325h-6.325V2.978zm6.604 28.292H6.009V2.73h13.648v7.438c0 .478.387.865.865.865h7.469V31.27z"}}),_c('path',{attrs:{"d":"M9.75 10.6h6.262a.432.432 0 000-.864H9.75a.432.432 0 000 .864zm-.432 3.468c0 .239.193.432.432.432h14.5a.432.432 0 000-.864H9.75a.432.432 0 00-.432.432z"}})])])
          )
        }
      }
    